import { useState, useEffect } from 'react';
import { DashboardWrapper, Footer } from 'src/shared';
import { UploadContainer } from 'src/shared/dashboardWrapper/components';
import {
  Container,
  Title,
  UploadButton,
  StatusMessage
} from './styles';
import { useAppDispatch } from 'src/hooks';
import { submitHDF5Upload, pollJobStatus } from 'src/reducers/upload';
import { useSelector } from 'react-redux';
import { selectUploadState } from 'src/reducers/upload';

const Upload = () => {
    const dispatch = useAppDispatch();
    const {
      loading,
      jobId,
      error,
      jobStatus,
      jobProgress,
      jobResultUrl,
      jobError: jobPollingError
    } = useSelector(selectUploadState);

    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [status, setStatus] = useState<string | null>(null);

    const handleSelect = (file: File) => {
        setSelectedFile(file);
        setStatus(`📂 Selected file: ${file.name}`);
    };

    const handleUpload = async () => {
        if (!selectedFile) return;
            setStatus('🔄 Uploading...');

        try {
            const result = await dispatch(submitHDF5Upload(selectedFile)).unwrap();
            setStatus('✅ Job submitted successfully!');
        } catch (err) {
            // TODO: retry policies
            console.error('Upload or job submission failed:', err);
            setStatus('❌ Upload or submission failed.');
        }
    };

    // Poll job status when jobId is available
    useEffect(() => {
        if (!jobId) return;

        console.log('[Polling useEffect] jobId:', jobId);

        const intervalId = setInterval(() => {
            // Only keep polling if job is not yet completed or failed
            if (jobStatus !== 'completed' && jobStatus !== 'failed') {
                console.log('[Dispatching pollJobStatus]', jobId);
                dispatch(pollJobStatus(jobId));
            } else {
                console.log('[Polling stopped]', jobStatus);
                clearInterval(intervalId);
            }
        }, 5000); // Poll every 5 seconds

        return () => clearInterval(intervalId); // Cleanup on unmount
    }, [jobId, jobStatus, dispatch]);

  return (
    <DashboardWrapper>
        <Container>
        <Title>Upload HDF5 for Analysis</Title>
        <UploadContainer onSelect={handleSelect} />
        <UploadButton onClick={handleUpload} disabled={!selectedFile || loading}>
            {loading ? 'Uploading...': 'Upload & Submit'}
        </UploadButton>

        {/* <StatusMessage>
            {status ? <div>{status}</div> : null}
            {jobId ? <div>Job ID: {jobId}</div> : null}
            {error ? <div style={{ color: 'red' }}>{error}</div> : null}
        </StatusMessage> */}

        <StatusMessage>
            {status ? <div>{status}</div> : null}
            {jobId ? <div>Job ID: {jobId}</div> : null}
            {error ? <div style={{ color: 'red' }}>{error}</div> : null}

            {jobId && (
              <>
                <div>Status: {jobStatus}</div>
                <div>Progress: {jobProgress}%</div>
                <div style={{
                  width: '100%',
                  backgroundColor: '#f3f3f3',
                  borderRadius: '5px',
                  overflow: 'hidden',
                  height: '20px',
                  marginBottom: '10px'
                }}>
                  <div style={{
                    width: `${jobProgress}%`,
                    backgroundColor: '#4caf50',
                    height: '100%',
                    transition: 'width 0.5s ease-in-out'
                  }}></div>
                </div>

                {jobResultUrl && (
                  <div>
                    ✅ <a href={jobResultUrl} target="_blank" rel="noopener noreferrer">Download Result</a>
                  </div>
                )}

                {jobPollingError && (
                  <div style={{ color: 'red' }}>❌ Error: {jobPollingError}</div>
                )}
              </>
            )}
          </StatusMessage>

        </Container>
        
        {/* Footer with version information */}
        <Footer />
    </DashboardWrapper>
  );
};

export default Upload;